"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

class Scrollbar extends _react.Component {
  render() {
    const _this$props = this.props,
          {
      children,
      containerRef
    } = _this$props,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["children", "containerRef"]);
    return /*#__PURE__*/_react.default.createElement(_reactPerfectScrollbar.default, (0, _extends2.default)({
      ref: containerRef
    }, otherProps), children);
  }

}

(0, _defineProperty2.default)(Scrollbar, "propTypes", {
  children: _propTypes.default.node,
  containerRef: _propTypes.default.func
});
(0, _defineProperty2.default)(Scrollbar, "defaultProps", {
  children: null,
  containerRef: null
});
var _default = Scrollbar;
exports.default = _default;